import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment} from 'react';
import apiRequest from '../../functions/api';
import { useMessage } from '../../context/message-context';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import {TextField, Card, MenuItem, Table, TableBody, TableCell, TableContainer, TableRow, Button, Box } from "@mui/material";
import Grid from '@mui/material/Grid'
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
import { SearchTextField,FullPageSpinner } from '../lib';
import MessageBox from '../shared/components/MessageBox';
import axios from 'axios';
import {API_BASE_URL} from '../../constants/apiConstants';
import openFile from "../shared/functions/download";
function Projektstamm(props) {
  const { t } = useTranslation();
    // Standardvariablen
    const {client, accessToken} = props;
    const {showErrorMessage} = useMessage();
    const [isLoading, setIsLoading] = useState(false);
    //Arbeitsvariablen
    const [a1,setA1]=useState("");
    const [a2,setA2]=useState("");
    const [a3,setA3]=useState("");
    const [open,setOpen]=useState("");
    const [neu,setNeu]=useState("");
    const [zusatz,setZusatz]=useState("");
    const [user,setUser]=useState("");
    const [projekt,setProjekt]=useState([]);
    const [kost,setKost]=useState([]);
    const [gruppen,setGruppen]=useState([]);
    const [users,setUsers]=useState([]);
    const [eigeneAnz,setEigeneAnz]=useState("");
    const [eigeneAAnz,setEigeneAAnz]=useState("");
    const [eigeneIAnz,setEigeneIAnz]=useState("");
    const [aktivAnz,setAktivAnz]=useState("");
    const [inaktivAnz,setInaktivAnz]=useState("");
    const [kostenstelle,setKostenstelle]=useState("");
    const [proj,setProj]=useState("");
    const [infoKenn,setInfoKenn]=useState("");
    const [infoBez,setInfoBez]=useState("");
    const [infoGrp,setInfoGrp]=useState("");
    const [infoGrpIndex,setInfoGrpIndex]=useState(0);
    const [infoZusatz,setInfoZusatz]=useState("");
    const [infoAktiv,setInfoAktiv]=useState("1");
    const [infoLeiterIndex,setInfoLeiterIndex]=useState(0);
    const [infoVertreterIndex,setInfoVertreterIndex]=useState(0);
    const [infoKz,setInfoKz]=useState("P");
    const [filter,setFilter]=useState("")
    const [messageBoxOpen,setMessageBoxOpen]=useState(false);
    const [spinner,setSpinner]=useState(false)
    //Funktionen
    useEffect(() => {
        setIsLoading(true);
        const payload={
            "mandant": client,
            "program": "PPROJ2",
            "statement": "LADEN",  
        }
        const headers={
            "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers, postLaden);
        //eslint-disable-next-line
    }, []);
    const postLaden=(response)=>{
        setIsLoading(false);
        if (response.status === 200) {
            if (response.data.message==="OK"){
                Reset()
                setUser(response.data.user)
                setProjekt(response.data.projekt)
                setKost(response.data.kost)
                setAktivAnz(response.data.aktivAnz)
                setInaktivAnz(response.data.inaktivAnz)
                setEigeneAnz(response.data.eigeneAnz)
                setEigeneAAnz(response.data.eigeneAAnz)
                setEigeneIAnz(response.data.eigeneIAnz)
                setGruppen(response.data.gruppen)
                setUsers(response.data.users)
                setZusatz(response.data.zusatz)
                
            } else {
                showErrorMessage(response.data.message);
            }
        } else {
            if (response) {
                showErrorMessage(response.data.message);
            } else {
                showErrorMessage(t("Keine Internetverbindung"));
            }
        }
    }
    function Speichern(){
        setIsLoading(true);
        const payload={
            "mandant": client,
            "program": "PPROJ2",
            "statement": "SPEICHERN",  
            "kenn":infoKenn,
            "bez":infoBez,
            "grpindex":(gruppen&&gruppen[infoGrpIndex])&&gruppen[infoGrpIndex].bez,
            "grp":infoGrp,
            "zusatz":infoZusatz,
            "aktiv":infoAktiv,
            "leiter":users[infoLeiterIndex].key,
            "vertreter":users[infoVertreterIndex].key,
            "edit":(proj!==""?"1":"0"),
            "kz":infoKz,
        }
        const headers={
            "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers, postLaden);
    }
    if (isLoading) {
        return <LoadingComponent />
    }
    function Excel(){
        setMessageBoxOpen(true)
    }
    const messageBoxResult = (result) => {
        setMessageBoxOpen(false);
        if (result==="YES"){
            setSpinner(true)
            downloadFile("active")
        }
        if (result==="NO"){
            setSpinner(true)
            downloadFile("all")
        }
        
    }
    function downloadFile(pkz){
        const payload={
            "mandant": client, // this.props.client,
            "program": "PPROJ2",
            "statement": "EXCEL",
            "projekte": pkz,
          }
          const headers={
              "Authorization": "Bearer "+accessToken,
              "Accept": "application/pdf"
          }
          axios.post(API_BASE_URL+'daten', payload, {headers: headers, responseType: 'blob'})
        .then((response) => {
            console.log(response);
            var fileName = "Auswertung_Projekte.xlsx"
            var contentFile = response.data;
            openFile(fileName, contentFile);
            setSpinner(false);
        })
        .catch(function (error) {
            console.log(error);
            setSpinner(false);
            showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
        });
    }
    function Reset(){
        (proj!==""?setA3(""):setA2(""))
        setProj("")
        setKostenstelle("")
        setNeu("")
        setInfoKenn("")
        setInfoBez("")
        setInfoGrp("")
        setInfoGrpIndex(0)
        setInfoZusatz("")
        setInfoAktiv("1")
        setInfoLeiterIndex(0)
        setInfoVertreterIndex(0)
        setInfoKz("P")
    }
    function LoadProj(index){
        setProj(index)
        setOpen("")
        setNeu("P")
        if (projekt[index].kz==="P"&&projekt[index].gruppe!==""&&gruppen&&gruppen.length>0){
            gruppen.forEach((item,index2)=>{
                if (projekt[index].gruppe===item.bez) {
                    setInfoGrpIndex(index2)
                }
            })
        }
        if (projekt[index].leiter!==""&&users&&users.length>0){
            users.forEach((item,index2)=>{
                if (projekt[index].leiter===item.key) {
                    setInfoLeiterIndex(index2)
                }
            })
        }
        if (projekt[index].vertreter!==""&&users&&users.length>0){
            users.forEach((item,index2)=>{
                if (projekt[index].vertreter===item.key) {
                    setInfoVertreterIndex(index2)
                }
            })
        }
        setInfoKenn(projekt[index].kenn)
        if (projekt[index].kz==="K") setInfoKenn(projekt[index].key.substr(1))
            console.log(projekt[index].key)
        setInfoBez(projekt[index].bez)
        setInfoZusatz(projekt[index].zusatz)
        setInfoAktiv(projekt[index].aktiv)
        setInfoKz(projekt[index].kz)
    }
    function LoadKost(index){
        setKostenstelle(index)
        setInfoKenn(kost[index].key)
        
        setInfoBez(kost[index].bez)
        setOpen("")
        setNeu("K")
        setInfoKz("K")
    }
    function Aktion1(aktion){
        if (aktion==="neu"){
            setA1("N")
        }
        if (aktion==="edit"){
            setA1("E")
        }
        setA2("")
        setA3("")
    }
    function Aktion2(aktion){
        if (aktion==="projekt"){
            setA2("P")
            setNeu("P")
        }
        if (aktion==="kostenstelle"){
            setA2("K")
            setOpen("K")
        }
        if (aktion==="eigene"){
            setA2("E")
        }
        if (aktion==="alle"){
            setA2("A")
        }
        setA3("")
    }
    function Aktion3(aktion){
        if (aktion==="aktiv"){
            setA3("A")
        }
        if (aktion==="inaktiv"){
            setA3("I")
        }
        setOpen("P")
    }
    function BezProj(item){
        var status=item.aktiv==="1"?"aktiv":"inaktiv"
        var kennung=item.kz==="K"?"Kostenstelle "+item.kenn:item.kenn
        return(
            <Fragment>
                {"Projektkennung: "+kennung}<br/>{"Status: "+status}<br/>{"Projektbezeichnung: "+item.bez}<br/>{"Projektleiter: "+item.leitername}
            </Fragment>
        )
    }
    function BezKost(item){
        return(
            <Fragment>
                {"Kostenstelle: "+item.vkey}<br/>{"Bezeichnung: "+item.bez}
            </Fragment>
        )
    }
    function Auswahl1(){
        return(
        <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                    <h4>{t("Auswahl Neu/Bearbeiten")}</h4>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Button
                        fullWidth
                        variant={(a1==="N")?"contained":"outlined"}
                        color="primary"
                        onClick={()=>Aktion1("neu")}
                    >
                        {t("Neues Projekt anlegen")}
                    </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Button
                        fullWidth
                        variant={(a1==="E")?"contained":"outlined"}
                        color="primary"
                        onClick={()=>Aktion1("edit")}
                    >
                        {t("Projekte bearbeiten")}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
        )
    }
    function Auswahl11(){
        return(
        <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                    <h4>{t("Auswahl Projekt/Kostenstelle")}</h4>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Button
                        fullWidth
                        variant={(a2==="P")?"contained":"outlined"}
                        color="primary"
                        onClick={()=>Aktion2("projekt")}
                    >
                        {t("Eigenes Projekt definieren")}
                    </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Button
                        fullWidth
                        variant={(a2==="K")?"contained":"outlined"}
                        color="primary"
                        onClick={()=>Aktion2("kostenstelle")}
                    >
                        {t("Kostenstelle auswählen")}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
        )
    }
    function Auswahl12(){
        return(
        <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                    <h4>{t("Auswahl eigene/alle Projekte")}</h4>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Button
                        fullWidth
                        variant={(a2==="E")?"contained":"outlined"}
                        color="primary"
                        onClick={()=>Aktion2("eigene")}
                    >
                        {"Nur eigene Projekte anzeigen ("+eigeneAnz+")"}
                    </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Button
                        fullWidth
                        variant={(a2==="A")?"contained":"outlined"}
                        color="primary"
                        onClick={()=>Aktion2("alle")}
                    >
                        {t("Alle Projekte anzeigen")}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
        )
    }
    function Auswahl2(){
        return(
        <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                    <h4>{t("Auswahl aktiv/inaktiv")}</h4>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Button
                        fullWidth
                        variant={(a3==="A")?"contained":"outlined"}
                        color="primary"
                        onClick={()=>Aktion3("aktiv")}
                    >
                        {(a2==="E")?"Aktive anzeigen ("+eigeneAAnz+")":"Aktive anzeigen ("+aktivAnz+")"}
                    </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Button
                        fullWidth
                        variant={(a3==="I")?"contained":"outlined"}
                        color="primary"
                        onClick={()=>Aktion3("inaktiv")}
                    >
                        {(a2==="E")?"Inaktive anzeigen ("+eigeneIAnz+")":"Inaktive anzeigen ("+inaktivAnz+")"}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
        )
    }
    function EditAuswahl(){
        return(
            <ResponsiveDialog 
                title={open==="P"?"Projekt/Kostenstelle auswählen" :"Kostenstelle auswählen"}
                open={open==="P"||open==="K"} 
                setOpen={(o) => {setOpen("");open==="P"?setA3(""):setA2("");setFilter("")}}
            >
                <Box p={2}>
                <SearchTextField
                            fullWidth
                            label={t("Suche")}
                            id="filter2"
                            variant="outlined"
                            value={filter}
                            inputProps={{
                            autoCapitalize: 'off',
                            autoCorrect: 'off',
                            spellCheck: 'false',
                            autoComplete: 'off'
                            }}
                            onChange={(e)=>setFilter(e.target.value)}
                        />
                </Box>
                <TableContainer>
                <Table>
                    <TableBody>
                        {(open==="P"&&projekt&&projekt.length>0)&&projekt.map((item,index)=>{
                            if (a2==="E"&&user!==item.leiter) return <Fragment/>;
                            if (a3==="A"&&item.aktiv!=="1") return <Fragment/>;
                            if (a3==="I"&&item.aktiv!=="0") return <Fragment/>;
                            if (item.kenn.toLowerCase().includes(filter.toLowerCase())===false&&item.bez.toLowerCase().includes(filter.toLowerCase())===false&&item.leitername.toLowerCase().includes(filter.toLowerCase())===false) return <Fragment/>;
        
                        
                            return(
                            <TableRow
                                style={{cursor: 'pointer'}}
                                onClick={() => LoadProj(index) }
                                hover
                            >
                                <TableCell>
                                    {BezProj(item)}
                                </TableCell>
                            </TableRow>
                            )
                        })}
                        {(open==="K"&&kost&&kost.length>0)&&kost.map((item,index)=>{
                            return(
                            <TableRow
                                style={{cursor: 'pointer'}}
                                onClick={() => LoadKost(index) }
                                hover
                            >
                                <TableCell>
                                    {BezKost(item)}
                                </TableCell>
                            </TableRow>
                            )
                        })}
                        {(open==="K"&&(!kost||kost.length<=0))&&
                            <TableRow><TableCell>{t("Es stehen keine Kostenstellen zur Auswahl")}</TableCell></TableRow>
                        }
                        {(open==="P"&&(!projekt||projekt.length<=0))&&
                            <TableRow><TableCell>{t("Es stehen keine Projekte zur Auswahl")}</TableCell></TableRow>
                        }
                    </TableBody>
                </Table>
                </TableContainer>
            </ResponsiveDialog>
            )
    }
    function Dateneingabe(){
        return(
            <ResponsiveDialog 
                title={t("Projektdetails")}
                open={neu!==""} 
                setOpen={(o) => {setNeu("");Reset()}}
                actionButton={
                    <Grid container justifyContent="center" spacing={1}>
                      <Grid item xs={12} sm={6}>
                        <Button fullWidth variant="outlined" color="primary" onClick={() => Reset()}>{t("Abbrechen")}</Button>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button fullWidth variant="outlined" color="primary" onClick={() => Speichern()}>{t("Speichern")}</Button>
                      </Grid>
                    </Grid>
                  }
            >
                <Box p={2}>
                    {proj!==""?DatenEdit():DatenNew()}
                </Box>
            </ResponsiveDialog>
            )
    }
    function DatenEdit(){
        return(
            <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
                <TextField
                    label={projekt[proj].kz==="P"?"Projektkennung":"Kostenstelle"}  
                    disabled
                    variant="outlined"
                    fullWidth
                    value={projekt[proj].kenn}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label={t("Beschreibung")}
                    disabled={projekt[proj].kz==="K"}
                    variant="outlined"
                    fullWidth
                    //value={projekt[proj].bez}
                    value={neu==="K"?kost[kostenstelle].bez:infoBez}
                    onChange={(e)=>setInfoBez(e.target.value)}
                />
            </Grid>
            {(projekt[proj].kz==="P"&&gruppen&&gruppen.length>0)&&
            <Fragment>
            <Grid item xs={12}>
                <TextField
                    label={t("Gruppe")}
                    variant="outlined"
                    fullWidth
                    select
                    value={infoGrpIndex}
                    onChange={(e)=>setInfoGrpIndex(e.target.value)}
                >
                    {gruppen.map((item,index)=>{
                        return(
                            <MenuItem key={index} value={index}>{item.bez}</MenuItem>
                        )
                    })}
                </TextField>
            </Grid>
            {infoGrpIndex===0&&
            <Grid item xs={12}>
                <TextField
                    label={t("Gruppenbezeichnung")}
                    variant="outlined"
                    fullWidth
                    value={infoGrp}
                    onChange={(e)=>setInfoGrp(e.target.value)}
                    inputProps={{
                        maxLength:15,
                    }}
                />
            </Grid>
            }
            </Fragment>
            }
            {(projekt[proj].kz==="P"&&zusatz==="J")&&
            <Grid item xs={12}>
                <TextField
                    label={t("Zusatz")}
                    variant="outlined"
                    fullWidth
                    value={infoZusatz}
                    onChange={(e)=>setInfoZusatz(e.target.value)}
                    inputProps={{
                        maxLength:10,
                    }}
                />
            </Grid>
            }
            <Grid item xs={12}>
                <TextField
                    label={t("Aktiv/Inaktiv")}
                    variant="outlined"
                    fullWidth
                    select
                    value={infoAktiv}
                    onChange={(e)=>setInfoAktiv(e.target.value)}
                >
                    <MenuItem key={"0"} value={"0"}>{"inaktiv"}</MenuItem>
                    <MenuItem key={"1"} value={"1"}>{"aktiv"}</MenuItem>
                </TextField> 
            </Grid>
            {(users&&users.length>0)&&
            <Grid item xs={12}>
                <TextField
                    label={t("Projektleiter")}
                    variant="outlined"
                    fullWidth
                    select
                    value={infoLeiterIndex}
                    onChange={(e)=>setInfoLeiterIndex(e.target.value)}
                >
                    {users.map((item,index)=>{
                        return(
                            <MenuItem key={index} value={index}>{item.name}</MenuItem>
                        )
                    })}
                </TextField>
            </Grid>
            }
            {(users&&users.length>0)&&
            <Grid item xs={12}>
                <TextField
                    label={t("Stellvertreter")}
                    variant="outlined"
                    fullWidth
                    select
                    value={infoVertreterIndex}
                    onChange={(e)=>setInfoVertreterIndex(e.target.value)}
                >
                    {users.map((item,index)=>{
                        return(
                            <MenuItem key={index} value={index}>{item.name}</MenuItem>
                        )
                    })}
                </TextField>
            </Grid>
            }
            </Grid>
        )
    }
    function DatenNew(){
        return(
            <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
                <TextField
                    label={neu==="P"?"Projektkennung":"Kostenstelle"}  
                    disabled={neu==="K"}
                    variant="outlined"
                    fullWidth
                    value={neu==="K"&&kost[kostenstelle]?kost[kostenstelle].vkey:infoKenn}
                    onChange={(e)=>{if (neu==="P") setInfoKenn(e.target.value)}}
                    //onChange={(e)=>setInfoKenn(e.target.value)}
                    inputProps={{
                        maxLength:12,
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label={t("Beschreibung")}
                    disabled={neu==="K"}
                    variant="outlined"
                    fullWidth
                    value={neu==="K"&&kost[kostenstelle]?kost[kostenstelle].bez:infoBez}
                    onChange={(e)=>setInfoBez(e.target.value)}
                    inputProps={{
                        maxLength:255,
                    }}
                />
            </Grid>
            {(neu==="P"&&gruppen&&gruppen.length>0)&&
            <Fragment>
            <Grid item xs={12}>
                <TextField
                    label={t("Gruppe")}
                    variant="outlined"
                    fullWidth
                    select
                    value={infoGrpIndex}
                    onChange={(e)=>setInfoGrpIndex(e.target.value)}
                >
                    {gruppen.map((item,index)=>{
                        return(
                            <MenuItem key={index} value={index}>{item.bez}</MenuItem>
                        )
                    })}
                </TextField>
            </Grid>
            {infoGrpIndex===0&&
            <Grid item xs={12}>
                <TextField
                    label={t("Gruppenbezeichnung")}
                    variant="outlined"
                    fullWidth
                    value={infoGrp}
                    onChange={(e)=>setInfoGrp(e.target.value)}
                    inputProps={{
                        maxLength:15,
                    }}
                />
            </Grid>
            }
            </Fragment>
            }
            {(neu==="P"&&zusatz==="J")&&
            <Grid item xs={12}>
                <TextField
                    label={t("Zusatz")}
                    variant="outlined"
                    fullWidth
                    value={infoZusatz}
                    onChange={(e)=>setInfoZusatz(e.target.value)}
                    inputProps={{
                        maxLength:10,
                    }}
                />
            </Grid>
            }
            <Grid item xs={12}>
                <TextField
                    label={t("Aktiv/Inaktiv")}
                    variant="outlined"
                    fullWidth
                    select
                    value={infoAktiv}
                    onChange={(e)=>setInfoAktiv(e.target.value)}
                >
                    <MenuItem key={"0"} value={"0"}>{"inaktiv"}</MenuItem>
                    <MenuItem key={"1"} value={"1"}>{"aktiv"}</MenuItem>
                </TextField> 
            </Grid>
            {(users&&users.length>0)&&
            <Grid item xs={12}>
                <TextField
                    label={t("Projektleiter")}
                    variant="outlined"
                    fullWidth
                    select
                    value={infoLeiterIndex}
                    onChange={(e)=>setInfoLeiterIndex(e.target.value)}
                >
                    {users.map((item,index)=>{
                        return(
                            <MenuItem key={index} value={index}>{item.name}</MenuItem>
                        )
                    })}
                </TextField>
            </Grid>
            }
            {(users&&users.length>0)&&
            <Grid item xs={12}>
                <TextField
                    label={t("Stellvertreter")}
                    variant="outlined"
                    fullWidth
                    select
                    value={infoVertreterIndex}
                    onChange={(e)=>setInfoVertreterIndex(e.target.value)}
                >
                    {users.map((item,index)=>{
                        return(
                            <MenuItem key={index} value={index}>{item.name}</MenuItem>
                        )
                    })}
                </TextField>
            </Grid>
            }
            </Grid>
        )
    }
    //Rueckgabe
    return(
        <Fragment>
        {EditAuswahl()}
        {Dateneingabe()}
        <Grid container justifyContent="center" spacing={2}>
        <Grid item xs={12} md={8}>
            <Card>
                <Box p={2}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={()=>Excel()}
                            >
                                {"Projekte in Excel auswerten"}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Card>
        </Grid>
        <Grid item xs={12} md={8}>
        <Card>
            <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                    {Auswahl1()}
                    {a1!==""&&<hr align="center" width="100%"/>}
                    {a1==="N"&&Auswahl11()}
                    {a1==="E"&&Auswahl12()}
                    {a2!==""&&<hr align="center" width="100%"/>}
                    {(a2==="E"||a2==="A")&&Auswahl2()}
                </Grid>
            </Box>
        </Card>
        </Grid>
        
        </Grid>
            <MessageBox 
                title={t("Auswahl Projekte")}
                text={t("Nur aktive Projekte auswerten?")}
                buttons="YESNOCANCEL"
                onClose={() => setMessageBoxOpen(false)}
                open={messageBoxOpen}
                handleResponse={(r)=>messageBoxResult(r)}
            />             
        {spinner && <FullPageSpinner/>}   
        </Fragment>
    )
}
export default Projektstamm;
